import { Theme, useMediaQuery } from '@mui/material';
import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  TextField,
  EditButton,
} from 'react-admin';
import BillerMobileGrid from './BillerMobileGrid';
import BillerMerchantCodesAside from './BillerMerchantCodesAside';
import { billerMerchantCodesFilters, useBillerGetFilters } from './BillerMerchantCodesFilters';

const BillerMerchantCodesList = () => {
  const { paymentGateways } = useBillerGetFilters();
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));

  return (
    <List
      exporter={false}
      hasCreate
      aside={<BillerMerchantCodesAside />}
      filters={billerMerchantCodesFilters({ paymentGateways })}
    >
      {isSmall ? (
        <BillerMobileGrid />
      ) : (
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField label="ID" source="id" />
          <TextField source="details" />
          <TextField label="Merchant ID" source="merchantId" />
          <TextField source="fee" />
          <TextField label="Payment Gateway" source="pgName" />
          <DateField label="Created At" source="createdAt" showTime />
          <DateField label="Updated At" source="updatedAt" showTime />
          <EditButton />
        </Datagrid>
      )}
    </List>
  );
};

export default BillerMerchantCodesList;
